'use strict';
/**
 * image lazyloading
 */
(function(w, d){
    var b = d.getElementsByTagName('body')[0];
    var s = d.createElement("script");
    var v = !("IntersectionObserver" in w) ? "8.17.0" : "10.20.0";
    s.async = true; // This includes the script as async. See the "recipes" section for more information about async loading of LazyLoad.
    s.src = "https://cdn.jsdelivr.net/npm/vanilla-lazyload@" + v + "/dist/lazyload.min.js";
    w.lazyLoadOptions = {elements_selector: ".lazy"};
    b.appendChild(s);
}(window, document));
(function ($) {
    $(document).on('click','.disabled',function (e) {
        e.preventDefault();
    });
    $.showModal = function (content, css) {
        $.fancybox.open('<div class="modal"><div class="modal__inner">' + content + '</div></div>');
    };
    // fix csrf-token
    $.ajaxPrefilter(function (options, originalOptions, xhr) {
        let csrf = $('meta[name=csrf-token]').attr('content');
        if (!options.crossDomain && csrf) {
            xhr.setRequestHeader('X-CSRF-Token', csrf);
        }
    });
    // Counter input increment/decrement buttons
    $(document).on('click', '.btn-counter', function (event) {
        const $input = $(this).siblings('input');
        const min_count = typeof $input.data('min') !== 'undefined' ? $input.data('min') : 1;
        const max_count = $input.data('max');
        const step = typeof $input.data('step') !== 'undefined' ? $input.data('step') : 1;
        let value = Number($input.val());
        if($(this).hasClass("btn-minus")){
            value -= step;
        } else {
            value += step;
        }
        if(typeof min_count !== 'undefined' && value < min_count) {
            value = min_count;
        }
        if(typeof max_count !== 'undefined' && value > max_count){
            value = max_count;
        }
        $input.val(value);
        $input.change();
        return false;
    });
    function init(){
        // lazy load
        //$('.lazy').lazy();
        // masked input
        $('input[type="tel"], .input-tel').mask('+380 (dd) ddd dddd', {
            translation: {
                'd': {pattern: /\d/},
                '0': false,
                //'9': {pattern: /\d/, optional: true},
                //'#': {pattern: /\d/, recursive: true},
                //'A': {pattern: /[a-zA-Z0-9]/},
                //'S': {pattern: /[a-zA-Z]/},
            },
            placeholder: "+380 (__) ___ ____"
        });
        // Counter input filter
        $(".input-counter").inputFilter(function (input) {
            const $input = $(input);
            let value = Number($input.val());
            if(!isNaN(value)){
                const min_count = typeof $input.data('min') !== 'undefined' ? $input.data('min') : 1;
                const max_count = $input.data('max');
                const step = typeof $input.data('step') !== 'undefined' ? $input.data('step') : 1;
                if(typeof min_count !== 'undefined' && value < min_count) {
                    value = min_count;
                }
                if(typeof max_count !== 'undefined' && value > max_count){
                    value = max_count;
                }
                if(step !== 'undefined'){
                    value = Math.ceil(value / step) * step;
                }
                $input.val(isNaN(value) ? 0 : value);
                return true;
            }
            return false;
        });
    }
    init();
    $(document).on('ajaxComplete ready', function (event) {
        init();
    });
    /**
     * init config on document ready
     */
    $(document).ready(function () {
        $.config = js_vars;
        $(document).trigger('js_ready', $.config);
        var toaster_html = $('#toastr');
        if (toaster_html.html().trim().length > 0) {
            toastr.options = {
                "closeButton": false,
                "debug": false,
                "newestOnTop": false,
                "progressBar": true,
                "positionClass": "toast-top-center",
                "preventDuplicates": false,
                "onclick": null,
                "showDuration": "300",
                "hideDuration": "1000",
                "timeOut": "15000",
                "extendedTimeOut": "1000",
                "showEasing": "swing",
                "hideEasing": "linear",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut"
            };
            toastr.success(toaster_html.html());
        }
    });
    /**
     * process config ready event
     */
    $(document).on('js_ready', function (event, config) {
        $.RelativeProductReload = function () {
            var prod_id = $('.product-info').attr('data-id');
            if (prod_id) {
                $('.similar-product-wrap').hide();
                $.get(config.links.related, {id: prod_id}, function (data) {
                    if (_.isEmpty(data.products.lenght)) {
                        $('.similar-product').html($.render('tmpl-product-card', data));
                        $('.similar-product-wrap').show();
                    }

                });
                $('.early-viewed-wrap').hide();
                $.get(config.links.early_viewed, {id: prod_id}, function (data) {
                    if (_.isEmpty(data.products.lenght)) {
                        $('.early-viewed').html($.render('tmpl-product-card', data));
                        $('.early-viewed-wrap').show();
                    }
                });
            }
        };
        /**
         * init cart module
         */
        $.Cart.init($.config.cart_settings);

        /**
         * add cart operations request handlers
         */
        $(document).on('click', $.Cart.settings.quick, function (event) {
            event.preventDefault();
            clearTimeout($.Cart.timeout.quick);

            var data = {
                id: $(this).attr($.Cart.settings.addattr),
                count: $($.Cart.settings.addcount + '[data-product=' + $(this).attr($.Cart.settings.addattr) + ']').val()
            };

            $.Cart.timeout.quick = setTimeout( function() {
                $.Cart.quick(data);
            }, 100);
        });
        $(document).on('click', 'button.quick-order', function (event) {
            event.preventDefault();
            clearTimeout($.Cart.timeout.quick);

            var form_data = new FormData($(this).closest('form').get(0));

            $.Cart.timeout.quick = setTimeout( function() {
                $.Cart.quick(form_data);
            }, 100);
        });
        $(document).on('click', $.Cart.settings.add, function (event) {
            event.preventDefault();
            clearTimeout($.Cart.timeout.add);

            var data = {
                id: $(this).attr($.Cart.settings.addattr),
                count: $($.Cart.settings.addcount + '[data-product=' + $(this).attr($.Cart.settings.addattr) + ']').val()
            };

            $.Cart.timeout.add = setTimeout(function() {
                $.Cart.add(data);
            }, 500);
        });
        $(document).on("submit", "form.cart-add", function (event) {
            event.preventDefault();
            var form_data = new FormData(this);
            $.Cart.timeout.add = setTimeout(function () {
                $.Cart.add(form_data)
                    .done(function (response_data) {});
            }, 500);
            return false;
        });
        $(document).on('change', $.Cart.settings.counta, function () {
            clearTimeout($.Cart.timeout.change);
            var self = this;
            $.Cart.timeout.change = setTimeout(function() {
                $.Cart.count({id: $(self).attr($.Cart.settings.countattr), count: $(self).val()});
            }, 500);
        });
        $(document).on('click', $.Cart.settings.del, function (e) {
            e.preventDefault();
            $.Cart.del({id: $(this).attr($.Cart.settings.delattr)});
        });
        $($.Cart.settings.clear).on('click', function () {
            $.Cart.clear();
        });

        /**
         * add cart operations response event handlers
         */
        $(document).on('updTpl.cart', function (event, data) {
            var basket = $('.header__basket');
            var order_cart = $('.order_cart');
            $('.cart-total-quantity').html(data.cart.cart.quantity);
            if (basket.length > 0) {
                var tmpl_cart = $.render('tmpl-cart', data.cart);
                basket.each(function (i, el) {
                    $(el).html(tmpl_cart);
                });
            }
            if (order_cart.length > 0) {
                order_cart.html($.render('tmpl-cart-full', $.extend(data.cart, {buttons: false})));
            }
            $(document).trigger('tmpl_rendered');
        });
        $(document).on('get.cart', function (event, data) {
            var header = $('.header-sign-in');
            if (header.length > 0) {
                header.html($.render('tmpl-profile-buttons', data.profile));
            }
        });
        $(document).on('add.cart', function (event, data) {
            /*$.Cart.showMessage(data.popup);*/
            if (data.analytics_data && data.analytics_data.dataLayer) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(data.analytics_data.dataLayer);
            }
            $.fancybox.open({'src': '#addCart', 'type': 'inline'});
        });
        $(document).on('quick.cart', function (event, data) {
            if (data.success) {
                $.showModal(data.content,'modal-thanks');
            } else {
                $.Cart.showMessage(data.popup);
            }
        });
        $(document).on('count.cart', function (event, data) {

            $.Cart.showMessage(data.popup);
        });
        $(document).on('del.cart', function (event, data) {
            $.Cart.showMessage(data.popup);
        });

        /**
         * wishlist operations
         */
        $(document).on('click', '.add-wishlist', function (event) {
            event.preventDefault();
            clearTimeout($.Cart.timeout.add);

            var data = {
                id: $(this).data('id')
            };

            function fun() {
                $.ajax({
                    url: js_vars.links.addWishlist,
                    type: 'post',
                    data: data,
                    dataType: 'json',
                    success: function success(response_data) {
                        $.Cart.showMessage(response_data.popup);
                    },
                    error: function error(xhr, ajaxOptions, thrownError) {
                        console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
                    }
                });
            }

            $.Cart.timeout.add = setTimeout(fun, 500);
        });
        $(document).on('click', '.del-wishlist', function (event) {
            event.preventDefault();
            clearTimeout($.Cart.timeout.del);

            var data = {
                id: $(this).data('id')
            };

            function fun() {
                $.ajax({
                    url: js_vars.links.delWishlist,
                    type: 'post',
                    data: data,
                    dataType: 'json',
                    success: function success(response_data) {
                        $.Cart.showMessage(response_data.popup);
                    },
                    error: function error(xhr, ajaxOptions, thrownError) {
                        console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
                    }
                });
            }

            $.Cart.timeout.del = setTimeout(fun, 500);
        });
        /**
         * comment toastr
         */
        $(document).on('comment-success', null, function (e, data) {
            data.success = true;
            $.Cart.showMessage(data);
        });
        /**
         * make ajax not war
         */
        $.Cart.get();
        $.RelativeProductReload();
    });
    /**
     * currency switcher DOM element handler
     */
    $(document).on('click', '.cur-switcher .header-dropdown-menu a', function (event) {

        var currency = $(this).data('currency');
        event.preventDefault();
        $.ajax({
            url: '/site/switch-currency/',
            type: 'POST',
            dataType: 'json',
            data: {
                currency: currency
                // url: el.attr('data-url')
            },
            success: function success() {
                location.reload();
            }
        });
    });

    /**
     * submit form
     */
    $(document).on('click', '[data-submit]', function (event) {
        event.preventDefault();
        $('#' + $(this).attr('data-submit')).submit();
    });

    /**
     * send form over ajax and render html response in form parent element
     */
    var submit_timeout = void 0;$(document).on('submit', '[data-ajax=1]', function (event) {
        event.preventDefault();
        var form = $(this);
        var content = form.parent();
        var content_wrap = form.closest('.fancybox-slide');
        var close_popup = form.attr('data-need-to-close-popup');

        form.find('[type=submit]').each(function () {
            $(this).prop('disabled', true);
        });
        form.find('[type=submit]').each(function () {
            $(this).prop('disabled', true);
        });
        var closure = function () {
            $.ajax({
                url: form.attr('action'),
                type: form.attr('method'),
                data: form.serialize(),
                // dataType: 'html',
                // contentType:false,
                // processData:false,
                success: function (data) {
                    content.html(data);
                    if (typeof(close_popup) !== "undefined" && close_popup !== null && close_popup === '1'){
                        $("button.fancybox-close-small").click();
                    }
                    $(content_wrap.length ? content_wrap : 'html, body').animate({
                        scrollTop: form.offset().top - 100
                    }, 100);
                }
            }).always(function () {
                form.find('[type=submit]').each(function () {
                    $(this).prop('disabled', false);
                });
            });
        };
        clearTimeout(submit_timeout);
        submit_timeout = setTimeout(closure, 500);
        return false;
    });
    /**
     * open a href target in popup
     */
    var a_ajax_timeout = void 0;
    $(document).on('click', 'a.ajax, button.ajax', function (event) {
        event.preventDefault();
        var a = $(this);

        var cl = a.data('modal-class') ? a.attr('data-class') : '';
        var href=a.attr('href')?a.attr('href'):a.data('href');
        var closure = function closure() {
            $.ajax({
                url: href,
                success: function success(data) {
                    $.showModal(data, cl);
                },
                complete: function complete(xhr, status) {
                    // a.prop('disabled', false);
                }
            });
        };
        clearTimeout(a_ajax_timeout);
        a_ajax_timeout = setTimeout(closure, 500);
        clearTimeout($.Cart.timeout.change);
    });

    $(document).on('change', '.customer_type', function (e) {
        var el = $(e.target);
        $('.customer_form').each(function (i, item) {

            $(item).css("display", 'none');
        });
        $('.customer_form[data-type=' + el.val() + ']').css('display', 'flex');

    });
})(jQuery);
